<template>
  <div class="section-abstract-header">Données sociales</div>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionAccidentTravailListExtend', 'etablissement', true)">
      <v-col>
        <div class="section-abstract-title">Taux accident du travail (ATMP))</div>
        <div v-if="etablissement.accidentTravailCount >= 0" class="section-abstract-display">Vous avez {{ etablissement.accidentTravailCount }} Taux accident du travail renseigné(s)</div>
        <div v-else class="section-abstract-display">Ajouter un taux accident du travail</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
        </div>
      </v-col>
      <v-col cols="1" style=" align-content: center; align-items: center">
        <v-icon class="arrow-icon" style="font-size: 12px; color: #25A3A7;">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
    <v-row class="ma-0 abstract-row" @click="openSection('SectionAccordCollectifExtend', 'etablissement', false)">
      <v-col>
        <div class="section-abstract-title">Déduction forfaitaire spécifique (DFS) pour frais professionnels</div>
        <div class="section-abstract-display">{{accordCollectifLabel}}</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from "vue";
  import SectionEtablissementAccidentTravailAbstract from '@/generated/sections/SectionEtablissementAccidentTravailAbstract.vue';
  export default defineComponent({
    extends: SectionEtablissementAccidentTravailAbstract,
    components: {},
    computed: {
      accordCollectifLabel() {
        if (this.etablissement.accordCollectif) {
          return "J'ai conclu un accord collectif";
        } else {
          return "Je n'ai pas conclu d'accord collectif";
        }
      }
    },
    methods: {
      headerTitle(): string {
        return "Taux accident du travail pour " + this.etablissement.alias;
      },
    }
  })
</script>
